import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function Hero() {
  return <section className="relative pt-24 pb-16 px-6 sm:pt-32 sm:pb-24 overflow-hidden" data-id="element-67">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-64 bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-68" />

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-69">
        <FadeIn data-id="element-70">
          <h1 className="font-bebas text-5xl sm:text-7xl uppercase tracking-tight leading-[0.9] mb-6 text-center" data-id="element-71">
            Protocolo <span className="text-amber-500" data-id="element-72">Dopamina Cero</span>:
            <br data-id="element-73" />
            El Reinicio Neuroquímico de 21 Días
          </h1>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-74">
          <h2 className="text-xl sm:text-2xl text-zinc-300 font-medium text-center mb-12 leading-snug" data-id="element-75">
            Recupera tu enfoque masculino, elimina la niebla cerebral y destruye
            la adicción a la dopamina barata sin depender de la "fuerza de
            voluntad".
          </h2>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-76">
          <div className="bg-zinc-900/50 border border-zinc-800 rounded-xl p-6 sm:p-8 mb-8 relative" data-id="element-77">
            <div className="absolute -left-1 top-8 bottom-8 w-1 bg-amber-500 rounded-r-full" data-id="element-78" />
            <p className="text-lg text-zinc-300 italic leading-relaxed mb-6" data-id="element-79">
              "Son las 11:30 PM. Estás solo con tu teléfono. No es deseo real,
              es un impulso automático que ya ni siquiera disfrutas. Sabes que
              después de esos 10 minutos de placer sintético vienen tres días de
              culpa, agotamiento mental y una apatía que te está robando tus
              mejores años."
            </p>
            <p className="text-lg text-zinc-300 leading-relaxed" data-id="element-80">
              Si sientes que has perdido el mando de tu propia vida, no es
              porque seas débil. Es porque tu cerebro ha sido secuestrado por
              algoritmos diseñados para explotar tu biología.
            </p>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} className="flex justify-center mt-12" data-id="element-81">
          <motion.a href="#offer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="inline-block bg-amber-500 text-zinc-950 font-bold text-lg sm:text-xl px-8 py-5 rounded-lg uppercase tracking-wide shadow-[0_0_30px_rgba(245,158,11,0.3)] hover:shadow-[0_0_40px_rgba(245,158,11,0.5)] transition-shadow" data-id="element-82">
            Quiero Reiniciar Mi Cerebro Ahora
          </motion.a>
        </FadeIn>
      </div>
    </section>;
}